import { useState, useEffect } from 'react';
import axios from 'axios';
import { useAuth } from "../contexts/auth";
import { getOrdersMechanicSummaryURL } from '../utils/api';

const useGetOrdersMechanicSummary = ({ 
        setErrors
    }) => {
        
    const { auth } = useAuth();
    const [ gettingOrders, setGettingOrders ] = useState(false);
    const [ orders, setOrders ] = useState([]);
    const [ gettingOrdersReqSuccess, setGettingOrdersReqSuccess ] = useState(false);
    
    useEffect(() => {

        if (gettingOrders) {
            axios.get(getOrdersMechanicSummaryURL, 
            {
                headers: {
                    Authorization: `Bearer ${auth.authToken}`
                },
                params: {}
            }).then(result => {
                setGettingOrders(false);
                if (result.status === 200) {
                    const data = result.data.data;
                    setGettingOrdersReqSuccess(true);
                    setOrders(data);         
                } else {
                    // console.log(result.data.errors);
                    if (setErrors) {
                        setErrors(result.data.errors);
                    }
                    setGettingOrdersReqSuccess(false);
                    // setOperatorAddErrors(result.data.errors);
                }
            }).catch(e => {
                if (e.response === undefined) {
                    // console.log(e);
                    if (setErrors) {
                        setErrors(['Could not connect to server']);
                    }
                    // setOperatorAddErrors(['Could not connect to server!'])
                } else {
                    // console.log(e.response.data.errors);
                    // setOperatorAddErrors(e.response.data.errors)
                    if (setErrors) {
                        setErrors([e.response.data.errors]);
                    }
                }
                setGettingOrdersReqSuccess(false);
                setGettingOrders(false);
            });
        }
    }, [gettingOrders]);

    return { orders, gettingOrders, setGettingOrders, gettingOrdersReqSuccess };
}

export default useGetOrdersMechanicSummary;